var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 55,
    viewBox: "0 0 149 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2643_56466)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2643_56466)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2643_56466",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 119,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.651 0H15.3516V54.0671H133.651V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2643_56466)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2643_56466",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 119,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.651 0H15.3516V54.0671H133.651V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2643_56466)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2643_56466",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 16,
    width: 58,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.803 16.0508H45.7793V38.8604H102.803V16.0508Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2643_56466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7793 16.0508V17.6114H56.8788V16.0508H45.7793ZM58.4515 16.0508V17.6114H74.2689C74.2689 17.6114 72.6532 16.0508 70.5134 16.0508H58.4515ZM77.3718 16.0508V17.6114H86.9411L86.3732 16.0508H77.3718ZM93.8018 16.0508L93.2338 17.6114H102.716V16.0508H93.8018ZM45.7793 19.0857V20.6463H56.8788V19.0857H45.7793ZM58.4515 19.0879V20.6463H76.1044C76.1044 20.6463 75.8982 19.4452 75.5386 19.0879H58.4515ZM77.3718 19.0879V20.6463H87.9903L87.4647 19.0879H77.3718ZM92.6658 19.0879L92.1401 20.6463H102.716V19.0879H92.6658ZM48.969 22.1207V23.6834H53.776V22.1207H48.969ZM61.6413 22.1207V23.6834H66.4482V22.1207H61.6413ZM71.1237 22.1207V23.6834H75.9306C75.9306 23.6834 76.2358 22.8581 76.2358 22.1207H71.1237ZM80.5616 22.1207V23.6834H89.084L88.516 22.1207H80.5616ZM91.6189 22.1207L91.0486 23.6834H99.6135V22.1207H91.6189ZM48.969 25.1578V26.7184H53.776V25.1578H48.969ZM61.6413 25.1578V26.7184H73.9193C73.9193 26.7184 74.9463 25.9176 75.2736 25.1578H61.6413ZM80.5616 25.1578V26.7184H85.3685V25.8497L85.6737 26.7184H94.479L94.8065 25.8497V26.7184H99.6135V25.1578H90.5898L90.1109 26.4796L89.6297 25.1578H80.5616ZM48.969 28.1927V29.7533H53.776V28.1927H48.969ZM61.6413 28.1927V29.7533H75.2736C74.9463 28.996 73.9193 28.1927 73.9193 28.1927H61.6413ZM80.5616 28.1927V29.7533H85.3685V28.1927H80.5616ZM86.2417 28.1927L86.8232 29.7533H93.4254L93.9778 28.1927H86.2417ZM94.8065 28.1927V29.7533H99.6135V28.1927H94.8065ZM48.969 31.2277V32.7883H53.776V31.2277H48.969ZM61.6413 31.2277V32.7883H66.4482V31.2277H61.6413ZM71.1237 31.2277V32.7883H76.2358C76.2358 32.0518 75.9306 31.2277 75.9306 31.2277H71.1237ZM80.5616 31.2277V32.7883H85.3685V31.2277H80.5616ZM87.3332 31.2277L87.8968 32.7883H92.3228L92.8908 31.2277H87.3332ZM94.8065 31.2277V32.7883H99.6135V31.2277H94.8065ZM45.8661 34.2626V35.8254H56.9658V34.2626H45.8661ZM58.4515 34.2626V35.8254H75.5386C75.8982 35.4675 76.1044 34.2626 76.1044 34.2626H58.4515ZM77.4587 34.2626V35.8254H85.3685V34.2626H77.4587ZM88.4269 34.2626L89.0061 35.8254H91.2581L91.8015 34.2626H88.4269ZM94.8065 34.2626V35.8254H102.803V34.2626H94.8065ZM45.8661 37.2998V38.8604H56.9658V37.2998H45.8661ZM58.4515 37.2998V38.8582H70.5134C72.6532 38.8582 74.269 37.2998 74.269 37.2998H58.4515ZM77.4587 37.2998V38.8604H85.3685V37.2998H77.4587ZM89.525 37.2998L90.0819 38.856L90.1778 38.8582L90.7435 37.2998H89.525ZM94.8065 37.2998V38.8604H102.803V37.2998H94.8065Z",
    fill: "#172342",
    fillOpacity: 0.6
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2643_56466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.33,
    height: 54.33,
    fill: "white",
    transform: "translate(0.335938)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2643_56466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.33,
    height: 54.33,
    fill: "white",
    transform: "translate(0.335938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.4044216dc73865d5ada54a0fba4777d1.svg";
export { ForwardRef as ReactComponent };